(function ($, window, undefined) {

    (function () {
        'use strict';

        $('.showpass').on('click', function () {
            if ($('.wrapper-login .senha').attr('type') == 'text') {
                $('.wrapper-login .senha').attr('type', 'password');
            } else {
                $('.wrapper-login .senha').attr('type', 'text');
            }
            return false;
        });


        var animacaoAbrir = function () {

            
            if ($('#masterslider').length == 1) {
                $('html, body').animate({
                    scrollTop: 0
                }, 'fast');
                $('#login').addClass('notbanner');
                $('#masterslider').masterslider('pause');
               

            } else {
                $('#login').addClass('notbanner');
                $('.container, main').addClass('blur');
            }

            $('#login').fadeIn();

            setTimeout(function () {
                $('#login .solutions').animate({
                    opacity: 1
                });
            }, 200);

            $('body').css({
                'position': 'fixed',
                'overflow-y': 'scroll'
            }).addClass('onLogin');
        };

        var verificarHashLogin = function () {

            var hash = window.location.hash;

            if (hash === '#login') {

                animacaoAbrir();

            }

        };


        // Fazer login mask
        $('.fazer-login').on('click', function (event) {

            event.preventDefault();

            window.location.hash = 'login';

        });

        $(window).on('load', function () {
            verificarHashLogin();
        });

        $(window).on('hashchange', function () {
            verificarHashLogin();
        });

        $(document).on('touchmove mousewheel DOMMouseScroll', '#login', function (e) {
            e.preventDefault();
        });

        $('#login .solutions').niceScroll();
    }());


    var animacaoFechar = function () {
        if ($('#masterslider').length){
            $('#masterslider').masterslider('resume');
        }

        $('#login .solutions').animate({
            opacity: 0
        });

        setTimeout(function () {
            $('#login').fadeOut();
        }, 200);

        window.location.hash = '';

        $('body').css({
            'position': 'static',
            'overflow-y': 'auto'
        }).removeClass('onLogin');
        $('.container, main').removeClass('blur');
        
        setTimeout(function () {
            $('.ms-slide .ms-caption').fadeIn();
        }, 400);
    };

    $('#login .btn-fechar').on('click', function () {

        animacaoFechar();

    });

    $('.select-solution ul li').on('click', function () {

        var urlSolucao = $(this).attr('data-url-solution');

        window.open(urlSolucao);

        animacaoFechar();

    });

    var hideShowlembrarSenha = function (make) {

        if (make == 'hide') {
            $('#form-api-login').find('input[name="Senha"]').fadeOut();
            $('.btn-enviar-form').text('Recuperar Senha').addClass('recover');
            $('.login-msg').hide();
            $('.recover-msg').show();
            $('#login .showpass').hide();
        } else {
            $('#form-api-login').find('input[name="Senha"]').fadeIn();
            $('.btn-enviar-form').text('Entrar').removeClass('recover');
            $('.login-msg').show();
            $('.recover-msg').hide();
            $('#login .showpass').show();
        }
    };


    var recuperarSenha = function () {
        $formLoginUser = $('#form-api-login').find('input[name="Nome"]').val();

        $.ajax({
            type: 'POST',
            url: 'https://login.advisebrasil.com.br/Login/LembrarSenha/',
            crossDomain: true,
            data: {
                'email': $formLoginUser,
            },
                beforeSend: function(){
                    $('#form-api-login').addClass('sending');
                },
                success: function(response){
                    $('#form-api-login').removeClass('sending');
                    if (response == 'OABSP') {
                        $('.error-msg.recover-msg').remove();
                        $('<div/>', {
                            'class': 'error-msg recover-msg',
                            'text': 'Favor entrar em contato com sua Seccional para alteração.'
                        }).appendTo('#form-api-login');
                    } else if (response == 'ENC') {
                        $('.error-msg.recover-msg').remove();
                        $('<div/>', {
                            'class': 'error-msg recover-msg',
                            'text': 'E-mail informado não esta cadastrado.'
                        }).appendTo('#form-api-login');
                    } else {
                        $('.error-msg.recover-msg').remove();
                        $('<div/>', {
                            'class': 'error-msg recover-msg',
                            'text': 'E-mail enviado com sucesso.'
                        }).appendTo('#form-api-login');

                        setTimeout(function () {
                            $('.error-msg.recover-msg').fadeOut(200);
                            hideShowlembrarSenha('show');
                        }, 3000);

                        
                    }

                    setTimeout(function () {
                        $('.error-msg.recover-msg').fadeIn(200);
                    },1000);

                 

                },
                error:function(){

                }
        

        });

    };
    

    var enviarDadosLogin = function () {

        var $formLogin = $('#form-api-login').find('input[name="Nome"]').val(),
            $formSenha = $('#form-api-login').find('input[name="Senha"]').val();

        if ($formLogin.length > 0 && $formSenha.length > 0) {

            $.ajax({
                type: 'POST',
               // url: 'http://localhost:3333/Login/ValidarUsuario/',
                url: 'https://login.advisebrasil.com.br/Login/ValidarUsuario/',
                crossDomain: true,
                data: {
                    'Nome': $formLogin,
                    'Senha': $formSenha
                },
                beforeSend: function () {
                    $('#form-api-login').addClass('sending');
                },
                success: function (response) {

                    console.log(response);

                    $('#form-api-login').removeClass('sending');

                    if (response.Sucesso) {

                        $('.error-msg').remove();

                        $('#form-api-login').removeClass('wobble-hor-bottom');

                        $('#form-api-login').submit();

                    } else {

                        $('.error-msg').remove();

                        $('#form-api-login').removeClass('wobble-hor-bottom');

                        $('<div/>', {
                            'class': 'error-msg login-msg',
                            'text': JSON.stringify(response.MgsErro)
                        }).appendTo('#form-api-login');

                        setTimeout(function () {
                            $('.error-msg').fadeIn(200);
                            $('#form-api-login').addClass('wobble-hor-bottom');
                        });
                    }
                },
                error: function (a, b, c) {
                    $('#form-api-login').removeClass('sending');

                    $('.error-msg').remove();
                    $('#form-api-login').removeClass('wobble-hor-bottom');

                    $('<div/>', {
                        'class': 'error-msg login-msg',
                        'text': 'Erro ao enviar dados. Tente novamente.'
                    }).appendTo('#form-api-login');

                    setTimeout(function () {
                        $('.error-msg').fadeIn(200);
                        $('#form-api-login').addClass('wobble-hor-bottom');
                    });
                }
            });

        } else {

            $formLogin = $('#form-api-login').find('input[name="Nome"]').focus();
            return false;

        }
    };


    $('#login .recover').on('click', function () {
        if($('#form-api-login .senha').is(':visible')){
            hideShowlembrarSenha('hide');
        } else {
            hideShowlembrarSenha('show');
        }
        
        return false;
    });

    

    $('.btn-enviar-form').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('recover')) {
            recuperarSenha();
        }else{
            enviarDadosLogin();
        }
    });

}(jQuery, window));